// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.elcol{\r\n  margin-bottom: 10px;\n}\n.el-cascader-panel{\r\n  height: 200px;\n}\r\n", ""]);
// Exports
module.exports = exports;
